import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import i18n from '../../../Utils/I18nUtil'
import Title from '../Atoms/Title'

const GeneratorHeader = ({labelColor}) => {
    return (
        <Fragment>
            <Title color={labelColor} padding={'20px 0 10px 0'}>
                {i18n('header.title')}
            </Title>
        </Fragment>
    )
}

GeneratorHeader.propTypes = {
    labelColor: PropTypes.string,
}

export default GeneratorHeader



// WEBPACK FOOTER //
// ./src/jsx/Components/Presentational/Organisms/GeneratorHeader.jsx